angular.module('v3sWbtPlayerApp').directive('v3sVideoThumbnail', ["$rootScope", "v3sContentMediaPath", "$modal", "v3sMediaService", "$window", function ($rootScope, v3sContentMediaPath, $modal, v3sMediaService, $window) {
    return {
        restrict: 'E',
        scope: true,
        link: function (scope, element, attrs) {
            var v3sVideo = scope.v3sVideo

            element.css({
                "background-image": "url(" + v3sContentMediaPath + v3sVideo.attr('v3s-poster') + ")",
                "width": v3sVideo.attr("v3s-width"),
                "height": v3sVideo.attr("v3s-height")
            });


            var vidpromise = v3sMediaService.getMedia(v3sVideo[0].id);
            vidpromise.then(function (media) {
                scope.vidSrc = media.src;
                scope.vidWidth = media.video.attr("v3s-width") || "80%";
                scope.vidHeight = media.video.attr("v3s-height") || "80%";
                scope.vidType = "video/" + scope.vidSrc.substr(scope.vidSrc.lastIndexOf('.') + 1);
            });

            var modal = $modal({
                container: "#wbtContent",
                prefixEvent: "videoModal",
                scope: scope,
                show: false,
                html: true,
                templateUrl: "app/js/page/elements/v3sVideoThumbnail.tpl.html"
            });

            $rootScope.$on('videoModal.show', function (evt, data) {
                var video = data.$element[0].querySelector('video');

                video.onended = function () {
                    modal.hide();
                }
            });
            modal.$promise.then(function () {
                element.on("click touchend", function (evt) {
                    modal.show();
                    evt.preventDefault();
                    evt.stopPropagation();
                });
            })
            scope.$on("$destroy", function () {
                if (!!modal) {
                    //Videomodal muss ggf auch zerstört werden
                    modal.destroy();
                    modal = null;
                }
            })
           
        }
    }
}]);